'use client'

import styles from './NossosRecursos.module.css';
import { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Button from "../../components/Button/Button";
import htmlParser from "html-react-parser";
import classNames from "classnames";
import "../../components/Button/Button.css";
import "react-tabs/style/react-tabs.css";
import "./tabs.css";
import Link from 'next/link';


// Importando o arquivo JSON diretamente
import RecursosHome from '../../jsons/RecursosHome.json';
import { useRouter } from 'next/navigation';

const NossosRecursos = () => {
    const navigate = useRouter();
  
 
    const [tabIndex, setTabIndex] = useState(0);
    const [abas, setAbas] = useState<any[]>([]);  
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);


    useEffect(() => {
        try {
            setAbas(RecursosHome);
            setLoading(false);
        } catch (err) {
            setError('Erro ao carregar os dados');
            setLoading(false);
        }
    }, []); 

    if (loading) {
        return (
            <div className="loading">Carregando...</div>
        );
    }

    if (error) {
        return (
            <div className="error">{error}</div>
        );
    }
    

    return (
        <section className={styles.nossosRecursos} id="nossosRecursos">
            <div className={styles.uiContainer}>
                <div className={styles.dFlex}>
                    <div className={styles.plataformaInteligente}>
                        <small className={styles.subtitle} tabIndex={0}>Nossos Recursos</small>
                        <h2 className={styles.title} tabIndex={0}>Uma plataforma <span>inteligente, segura</span> e <span>acessível</span> para todos</h2>
                        <p tabIndex={0}>A melhor experiência de usuário do mercado com navegação intuitiva em qualquer dispositivo e sistema operacional.</p>
                        <Link href="/Recursos" className={classNames('btnPadrao', 'btnBlue')} aria-label='Veja todos os Recursos da página Recursos'>Veja todos os Recursos</Link>
                    </div>

                    <div className={styles.containerRecursos}>
                        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                            <TabList>
                                {abas.map((aba, index) => (
                                    <Tab key={index} aria-label={'Tab' + aba.nomeaba}>{aba.nomeaba}</Tab>
                                ))}
                            </TabList>

                            {abas.map((aba, index) => (
                                <TabPanel key={index} className="fade-tab">
                                    <nav className={styles.conteudoComImagem}>
                                        <img src={aba.imagem} alt={`Imagem da ${aba.titulo}`} className={styles.imagemAba} loading="lazy" />
                                        <div className={styles.textoAba}>
                                            <h3 className={styles.title} tabIndex={0}>{aba.titulo}</h3>
                                            {htmlParser(aba.texto)}
                                        </div>
                                    </nav>
                                </TabPanel>
                            ))}
                        </Tabs>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NossosRecursos;
